if(!customElements.get('cart-recommended-products')){
    class CartRecommendedProducts extends HTMLElement {
        connectedCallback(){
            // defer one frame so the children are parsed even when this element
            // arrives via an innerHTML re-render of the drawer contents (the
            // init() guard makes this a no-op if the instance survived a move)
            requestAnimationFrame(() => {
                if(this.isConnected) this.init();
            });
        }

        init(){
            this.swiperContainer = this.querySelector('.swiper-container');
            if(!this.swiperContainer || this.swiperContainer.swiper) return;

            var swiperSettings = {
                init: true,
                loop: false,
                spaceBetween: 12,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                slidesPerView: 1,
                breakpoints: {
                    576: {
                        slidesPerView: 2
                    }
                },
                // the drawer is hidden/off-screen when this first runs and its
                // contents are swapped after cart changes - let Swiper re-measure
                // itself whenever visibility or the DOM changes
                observer: true,
                observeParents: true,
                observeSlideChildren: true
            };

            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
        }

        disconnectedCallback(){
            // the drawer re-renders its contents wholesale - clean up the old
            // instance so replaced elements don't leak observers. Deferred one
            // frame: renderDrawerSection moves this element back into the fresh
            // markup via replaceWith, and a moved (reconnected) instance must
            // keep its Swiper and scroll position.
            requestAnimationFrame(() => {
                if(!this.isConnected && this.swiper){
                    this.swiper.destroy(true, false);
                    this.swiper = null;
                }
            });
        }
    }

    customElements.define('cart-recommended-products', CartRecommendedProducts);
}
